var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.imagePath),expression:"imagePath"}],class:['lazy-image', _vm.className],style:({ height: _vm.customHeight || 'auto' }),on:{"load":_vm.handleImageLoad}})
}
var staticRenderFns = []

export { render, staticRenderFns }